import { EMPTY_ARR, EMPTY_OBJ } from '@dadohr/shared/domainTypes/emptyConstants';
import { TaskBlockDenormalized } from '@dadohr/shared/domainTypes/experience';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { TokenDefinition } from '../../../../../../components/MarkdownText';
import { AppThemeProviderWithOptionalCustomizations } from '../../../../../../themes/provider';
import {
  BlockList,
  MessageBody,
  MessageContainer,
  MessageHeader,
  MessageMainContainer,
  MessageSentByDadoFooter
} from '../../../../../Experiences/components/Builders/TaskBuilder/components/Messages';
import { TaskBuilderContext } from '../../../../../Experiences/components/Builders/TaskBuilder/types';
import { TaskBuilderBlockValidationState } from '../../../../../Experiences/components/Builders/TaskBuilder/validation';

export const BlockPreview = ({
  blocks,
  org,

  selectedBlock,
  onSelectBlock,
  onDeleteBlocks,
  onDuplicateBlock,
  validation,
  tokens,
  builderContext,
  emptyState,
  draggable
}: {
  blocks: TaskBlockDenormalized[];
  org: IOrganization;

  selectedBlock: string | null;
  onSelectBlock?: (nextSelected: string | null) => void;
  onDeleteBlocks?: (blockIds: string[]) => void;
  onDuplicateBlock?: (blockId: string) => void;
  validation: TaskBuilderBlockValidationState;
  tokens: TokenDefinition[];
  builderContext: TaskBuilderContext;
  draggable: boolean;

  emptyState: React.ReactNode;
}) => {
  return (
    <AppThemeProviderWithOptionalCustomizations theme={org.experienceTheming}>
      <MessageContainer>
        <MessageHeader logoUrl={org.logoUrl} />
        <MessageMainContainer>
          <MessageBody>
            <BlockList
              bs={blocks}
              expTpl={builderContext}
              selectedBlock={selectedBlock}
              onSelectBlock={onSelectBlock}
              onDeleteBlocks={onDeleteBlocks}
              onDuplicateBlock={onDuplicateBlock}
              emptyState={emptyState}
              validation={validation}
              tokens={tokens}
              anchorFields={EMPTY_ARR}
              flags={EMPTY_OBJ}
              draggable={draggable}
            />
          </MessageBody>
          <MessageSentByDadoFooter />
        </MessageMainContainer>
      </MessageContainer>
    </AppThemeProviderWithOptionalCustomizations>
  );
};
